import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { NavigateLink } from '../navigate/NavigateLinks';
import { GlobalButtonVariant } from './GlobalButton';
import GlobalButton from './GlobalButton';
import useModuleDashboard from '@/hooks/useModuleDashboard';

export interface BackToModuleButtonProps {
  breadcrumbs: NavigateLink[];
  label?: string;
  variant?: GlobalButtonVariant;
  disabled?: boolean;
}

const BackToModuleButton = ({
  breadcrumbs,
  label = 'Volver',
  variant = GlobalButtonVariant.secondaryButton,
  disabled = false,
}: BackToModuleButtonProps) => {
  
  const navigateToDashboard = useModuleDashboard(breadcrumbs);

  if (!navigateToDashboard) {
    return null;
  }

  return (
    <GlobalButton
      variant={variant}
      action={navigateToDashboard}
      disabled={disabled}
    >
      <ArrowBackIcon color='primary' />
      {label}
    </GlobalButton>
  );
};

export default BackToModuleButton;
